<div class="utilityFilter">
  {{ label }}
    <select name="utility-select" (change)="selectUtilityChild($event)" class="form-select">
      <option *ngFor="let u of utilityList" value={{u.key}}>
        {{u.value}}
      </option>
    </select>
</div>